import React from "react";
import { Avatar, Box, Chip } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicChipDemo = () => {

  return (
    <Box mb={2}>
      <PreviewAndEditor
        title={"Default Chip"}
        language={"js"}
        value={"    <Chip label=\"Default Chip\" />\n\n" +
            "        <Chip\n" +
            "          variant=\"tonal\"\n" +
            "          label=\"Default Delete Chip\"\n" +
            "          onDelete={() => console.log(\"On Delete\")}\n" +
            "          onClick={handleClick}\n" +
            "        />\n\n" +
            "        <Chip\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          label=\"Default Avatar Chip\"\n" +
            "          onClick={() => console.log(\"On Click\")}\n" +
            "        />"}
      >
        <Chip label="Default Chip" />
        <Chip
          variant="tonal"
          label="Default Delete Chip"
          onDelete={() => console.log("On Delete")}
          onClick={() => console.log("On Click")}
        />
        <Chip
          avatar={<Avatar>H</Avatar>}
          label="Default Avatar Chip"
          onClick={() => console.log("On Click")}
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default BasicChipDemo;
